import React from "react";

/**
 * Símbolo "P" da PROSEG PAY.
 * O PNG original do design (assets/proseg-p.png) não pôde ser exportado pela
 * API do Claude Design (limite de 256 KiB); o SVG abaixo é uma aproximação
 * vetorial. Para usar o arquivo oficial, salve-o em
 * public/img/prosegpay/proseg-p.png e troque a constante abaixo.
 */
export const PROSEG_MARK_SRC = "/img/prosegpay/proseg-p.svg";

const cx = (...parts) => parts.filter(Boolean).join(" ");

export const ProsegMark = ({ size, className, style, alt = "", eager = false }) => (
  <img
    src={PROSEG_MARK_SRC}
    alt={alt}
    aria-hidden={alt ? undefined : "true"}
    className={cx("pp-lockup-mark", className)}
    style={size == null ? style : { width: size, height: size, ...style }}
    loading={eager ? "eager" : "lazy"}
    decoding="async"
  />
);

/** Lockup horizontal: símbolo + "PROSEG PAY" (PAY em azul). */
export const ProsegLockup = ({ className, style, label = "PROSEG PAY", eager = false }) => (
  <span role="img" aria-label={label} className={cx("pp-lockup", className)} style={style}>
    <ProsegMark eager={eager} />
    <span className="pp-lockup-word" aria-hidden="true">
      PROSEG <em>PAY</em>
    </span>
  </span>
);
